import {
  BankOutlined,
  DashboardOutlined,
  PercentageOutlined,
  ScheduleOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  TagsOutlined,
} from "@ant-design/icons";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { ROUTE_PATHS } from "const/paths";
import { ItemType } from "antd/es/menu/hooks/useItems";

export const MAIN_MENU_ITEMS: ItemType[] = [
  {
    label: (
      <Link to={ROUTE_PATHS.Dashboard}>
        <FormattedMessage defaultMessage="Dashboard" />
      </Link>
    ),
    key: ROUTE_PATHS.Dashboard,
    icon: <DashboardOutlined />,
  },
  {
    label: <FormattedMessage defaultMessage="Organizations" />,
    key: `ROOT_${ROUTE_PATHS.OrganizationsList}`,
    icon: <BankOutlined />,
    children: [
      {
        label: (
          <Link to={ROUTE_PATHS.OrganizationsList}>
            <FormattedMessage defaultMessage="List" />
          </Link>
        ),
        key: ROUTE_PATHS.OrganizationsList,
      },
      {
        label: (
          <Link to={ROUTE_PATHS.OrganizationCreate}>
            <FormattedMessage defaultMessage="Create" />
          </Link>
        ),
        key: ROUTE_PATHS.OrganizationCreate,
      },
    ],
  },
  {
    label: <FormattedMessage defaultMessage="Venues" />,
    key: `ROOT_${ROUTE_PATHS.VenuesList}`,
    icon: <ShopOutlined />,
    children: [
      {
        label: (
          <Link to={ROUTE_PATHS.VenuesList}>
            <FormattedMessage defaultMessage="List" />
          </Link>
        ),
        key: ROUTE_PATHS.VenuesList,
      },
      {
        label: (
          <Link to={ROUTE_PATHS.VenuesCreate}>
            <FormattedMessage defaultMessage="Create" />
          </Link>
        ),
        key: ROUTE_PATHS.VenuesCreate,
      },
    ],
  },
  {
    label: <FormattedMessage defaultMessage="Events" />,
    key: `ROOT_${ROUTE_PATHS.Events}`,
    icon: <ScheduleOutlined />,
    children: [
      {
        label: (
          <Link to={ROUTE_PATHS.EventList}>
            <FormattedMessage defaultMessage="List" />
          </Link>
        ),
        key: ROUTE_PATHS.EventList,
      },
      {
        label: (
          <Link to={ROUTE_PATHS.Events}>
            <FormattedMessage defaultMessage="Create" />
          </Link>
        ),
        key: ROUTE_PATHS.Events,
      },
    ],
  },
  {
    label: <FormattedMessage defaultMessage="Recuring events" />,
    key: `ROOT_${ROUTE_PATHS.RecuringEvents}`,
    icon: <ScheduleOutlined />,
    children: [
      {
        label: (
          <Link to={ROUTE_PATHS.RecuringEventList}>
            <FormattedMessage defaultMessage="List" />
          </Link>
        ),
        key: ROUTE_PATHS.RecuringEventList,
      },
      {
        label: (
          <Link to={ROUTE_PATHS.RecuringEvents}>
            <FormattedMessage defaultMessage="Create" />
          </Link>
        ),
        key: ROUTE_PATHS.RecuringEvents,
      },
    ],
  },
  {
    label: <FormattedMessage defaultMessage="Ticket Templates" />,
    key: `ROOT_${ROUTE_PATHS.TicketTemplateList}`,
    icon: <TagsOutlined />,
    children: [
      {
        label: (
          <Link to={ROUTE_PATHS.TicketTemplateList}>
            <FormattedMessage defaultMessage="List" />
          </Link>
        ),
        key: ROUTE_PATHS.TicketTemplateList,
      },
      {
        label: (
          <Link to={ROUTE_PATHS.TicketTemplateCreate}>
            <FormattedMessage defaultMessage="Create" />
          </Link>
        ),
        key: ROUTE_PATHS.TicketTemplateCreate,
      },
    ],
  },
  {
    label: <FormattedMessage defaultMessage="Discount Codes" />,
    key: `ROOT_${ROUTE_PATHS.DiscountCodeList}`,
    icon: <PercentageOutlined />,
    children: [
      {
        label: (
          <Link to={ROUTE_PATHS.DiscountCodeList}>
            <FormattedMessage defaultMessage="List" />
          </Link>
        ),
        key: ROUTE_PATHS.DiscountCodeList,
      },
      {
        label: (
          <Link to={ROUTE_PATHS.DiscountCodeCreate}>
            <FormattedMessage defaultMessage="Create" />
          </Link>
        ),
        key: ROUTE_PATHS.DiscountCodeCreate,
      },
    ],
  },
  {
    label: (
      <Link to={ROUTE_PATHS.OrderList}>
        <FormattedMessage defaultMessage="Orders" />
      </Link>
    ),
    key: ROUTE_PATHS.OrderList,
    icon: <ShoppingCartOutlined />,
  },
];
